import { responsive } from "@huub-web/ui/utils/responsive";
import { style } from "@vanilla-extract/css";

/**
 * Mobile-only wrapper for the photos icon button. Position relative so the
 * count badge can be positioned over the icon. Hidden on larger screens.
 */
export const photosIconButtonWrapperStyle = style({
  position: "relative",
  display: "inline-flex",
  ...responsive({
    s: {
      display: "none",
    },
  }),
});

/**
 * Desktop-only wrapper for the full photos button with an inline count badge.
 * Hidden on mobile where the icon button is shown instead.
 */
export const photosButtonWrapperStyle = style({
  display: "none",
  ...responsive({
    s: {
      display: "inline-flex",
    },
  }),
});
